import { useState, useEffect } from 'react';
import api from '../services/api';

// Merkezi döviz listesi hook - currencies tablosundan gelir
let cachedCurrencies = null;
let fetchPromise = null;

export function useCurrencies() {
  const [currencies, setCurrencies] = useState(cachedCurrencies || []);
  const [loading, setLoading] = useState(!cachedCurrencies);

  useEffect(() => {
    if (cachedCurrencies) { setCurrencies(cachedCurrencies); setLoading(false); return; }
    if (!fetchPromise) {
      fetchPromise = api.get('/exchange/currencies').then(r => {
        if (r.data.success) { cachedCurrencies = r.data.data; }
        return cachedCurrencies || [];
      }).catch(() => []);
    }
    fetchPromise.then(data => { setCurrencies(data); setLoading(false); });
  }, []);

  // Cache'i temizle (yeni para birimi eklenince)
  const refresh = () => {
    cachedCurrencies = null;
    fetchPromise = null;
    api.get('/exchange/currencies').then(r => {
      if (r.data.success) { cachedCurrencies = r.data.data; setCurrencies(r.data.data); }
    });
  };

  return { currencies, loading, refresh };
}

// Döviz kodu listesi (sadece kodlar)
export function useCurrencyCodes() {
  const { currencies } = useCurrencies();
  return currencies.map(c => c.code);
}
